jQuery(document).ready(function ($) {

    /* ==========================================================================
    == MENU ACCESSIBLE ==
    ========================================================================== */

    $('.menu > ul > .menu-item-has-children').bind('mouseover focusin', function() {
        $(this).find('> .sub-menu').addClass('is-visible');
        $(this).find('> a').attr("aria-expanded","true");
    })
    $('.menu > ul > .menu-item-has-children').bind('mouseout focusout', function() {
        $(this).find('> .sub-menu').removeClass('is-visible');
        $(this).find('> a').attr("aria-expanded","false");
    });



    /* ==========================================================================
    == [RWD] - RECHERCHE ==
    ========================================================================== */

    $('.search-toggle').click(function () {
        $(this).toggleClass('is-active');
        $('.header-search').toggleClass('is-open');
        return false;
    });



    /* ==========================================================================
    == [RWD] - MENU ==
    ========================================================================== */

    $('.nav-toggle').click(function () {
        $('.header-main').addClass('is-open');
        $('body').addClass('nav-active');
        return false;
    });

    $('.nav-close').click(function () {
        $('.header-main').removeClass('is-open');
        $('body').removeClass('nav-active');
        return false;
    });



    /* ==========================================================================
    == TABS ==
    ========================================================================== */



    $('.tabs-nav-item').click(function(){

        var tab_id = $(this).attr('aria-controls');

        // reset
        $('.tabs-nav-item').attr("aria-selected","false");
        $('.tabs-nav-item').attr("tabindex","-1");
        $('.tabs-panel').attr("aria-hidden","true");

        // activation
        $(this).attr("aria-selected","true");
        $(this).attr("tabindex","0");
        $("#"+tab_id).attr("aria-hidden","false");

    });

    $('.tabs-nav-item').keydown(function(ev) {
        if (ev.which ==13) {
            $(this).click()
        }
    });


    var intervalID;
    var vitesse = 5000;
    var autoplay = true;
    $("#tabs-play").click(function(e){
        clearInterval(intervalID);
        intervalID = setInterval(tabsAvance,vitesse);
        autoplay = true;
    });
    $("#tabs-pause").click(function(e){
        clearInterval(intervalID);
        autoplay = false;
    });
    $("#tabs-prev").click(function(e){
        tabsAvance("prev");
    });
    $("#tabs-next").click(function(e){
        tabsAvance();
    });
    $(".tabs-nav-item, .tabs-panel").mouseenter(function() {
        autoplayOldValue = autoplay;
        $("#tabs-pause").click();
        autoplay = autoplayOldValue;
    });
    $(".tabs-nav-item, .tabs-panel").mouseleave(function() {
        if( autoplay === true ) {
            autoplayOldValue = autoplay;
            $("#tabs-play").click();
            autoplay = autoplayOldValue;
        }
    });
    $(".tabs-nav-item").focus(function() {
        autoplayOldValue = autoplay;
        $("#tabs-pause").click();
        autoplay = autoplayOldValue;

    });
    $(".tabs-nav-item").keydown(function(e){
        var keys = {
            end: 35,
            home: 36,
            left: 37,
            up: 38,
            right: 39,
            down: 40,
        };
        switch (e.which) {
            case keys.left:
            case keys.down:
                e.preventDefault();
                tabsAvance("next",true);
                break;
            case keys.right:
            case keys.up:
                e.preventDefault();
                tabsAvance("prev",true);
                break;
            case keys.home:
                e.preventDefault();
                tabsAvance("first",true);
                break;
            case keys.end:
                e.preventDefault();
                tabsAvance("last",true);
                break;
        };
    });
    $(".tabs-nav-item").blur(function() {
        if( autoplay === true ) {
            autoplayOldValue = autoplay;
            $("#tabs-play").click();
            autoplay = autoplayOldValue;
        }
    });
    if( $(".tabs-js-autoplay").length && autoplay === true ){
        $("#tabs-play").click();
    }

    function tabsAvance(sens,forcefocus){
        var tabFirst = $(".tabs-js-autoplay").find(".tabs-nav-item[aria-selected=true]");
        if( sens == "prev" ){
            if( !tabFirst.length ) {
                tabPrev = $(".tabs-js-autoplay").find(".tabs-nav-item").last();
            }else{
                tabPrev = tabFirst.parent("li").prev().find(".tabs-nav-item");
                if( !tabPrev.length ) {
                    tabPrev = $(".tabs-js-autoplay").find(".tabs-nav-item").last();
                }
            }
            tabPrev.click();
            if( forcefocus == true) {
                tabPrev.focus();
            }
        }else if( sens == "first" ){
            $(".tabs-js-autoplay").find(".tabs-nav-item").first().click();
            if( forcefocus == true) {
                $(".tabs-js-autoplay").find(".tabs-nav-item").first().focus();
            }
        }else if( sens == "last" ){
            $(".tabs-js-autoplay").find(".tabs-nav-item").last().click();
            if( forcefocus == true) {
                $(".tabs-js-autoplay").find(".tabs-nav-item").last().focus();
            }
        }else{
            if( !tabFirst.length ) {
                //Si aucun tab n'est actif on partira du premier
                tabNext = $(".tabs-js-autoplay").find(".tabs-nav-item").first();
            }else{
                //On fait avancé jusqu'au prochain tab.
                tabNext = tabFirst.parent("li").next().find(".tabs-nav-item");
                if( !tabNext.length ) {
                    //S'il n'y a pas de prochain c'est qu'on est déjà à la fin alors on revient au début
                    tabNext = $(".tabs-js-autoplay").find(".tabs-nav-item").first();
                }
            }
            //On éxécute le clic pour changer l'onglet
            tabNext.click();
            if( forcefocus == true) {
                tabNext.focus();
            }
        }
    }





    /* ==========================================================================
    == SLIDER HOME ==
    ========================================================================== */

    $('.slider-inner').slick({
        slidesToShow : 1,
        autoplay     : true,
        autoplaySpeed: 8000,
        arrows       : false,
        fade         : true,
        speed        : 2000,
        pauseOnHover : false,
        cssEase      : 'linear'
    });


    /* ==========================================================================
    == FIX BACKGROUND FIXED IE ==
    ========================================================================== */

    if(navigator.userAgent.match(/MSIE 10/i) || navigator.userAgent.match(/Trident\/7\./) || navigator.userAgent.match(/Edge\/12\./)) {
        $('body').on("mousewheel", function () {
            event.preventDefault();
            var wd = event.wheelDelta;
            var csp = window.pageYOffset;
            window.scrollTo(0, csp - wd);
        });
    }



    /* ==========================================================================
    == FILTRE CARTE INTERACTIVE ==
    ========================================================================== */

    $("#carte-filtre").on("click","button",function(){
    	var json = $(this).data("uid");
    	$("#carte-filtre").find("button").removeClass("active");
    	$(this).addClass("active");

    	//on efface tout
    	for (var i = 0; i < markers.length; i++) {
          markers[i].setMap(null);
        }
    	if( json == "tous" ){
    		//on réaffiche tout
    		initMap();
    		return;
    	}

    	setMarkers(eval(json));
    });


    /* ==========================================================================
    == MEDIATEQUE CARROUSEL ==
    ========================================================================== */

    $('.mdtk-carrousel').slick({
        autoplay     : true,
        autoplaySpeed: 6000,
        slidesToShow : 7,
        prevArrow    : "<i class='slick-prev icon-chevron-left'></i>",
        nextArrow    : "<i class='slick-next icon-chevron-right'></i>",
        responsive: [
            {
                breakpoint: 1120,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 540,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });




});